
























































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Order, OrderExternalStatus } from '@/api'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import formatter from '@/helpers'

dayjs.extend(utc)
dayjs.extend(timezone)

@Component({})
export default class Status extends Vue {
  @Prop() order!: Order
  @Prop() email!: string
  @Prop(Boolean)header!: boolean

  public OrderExternalStatus = OrderExternalStatus

  public workTime (): boolean {
    return formatter.workTime()
  }

  public startWorkTime (): string {
    return formatter.startWorkTime()
  }

  public setPriceTo (value: string | undefined): string {
    return formatter.setPriceToWithOrder(value)
  }

  public messageTo (): string {
    // TODO FIX incorrect time, based on now
    // Must use some time from order
    return formatter.setPriceTo()
  }

  public orderReadyTime (value: string | undefined): string {
    return formatter.orderReadyTime(value)
  }

  public tzDiffer (): boolean {
    return formatter.tzDiffer()
  }
}
